<template>
  <form @submit.prevent="submit">
    <base-content>
      <template v-slot:top>
        <hero-header heading="Bank account for withdrawals" />
      </template>

      <div class="row">
        <div class="col-sm-6">
          <p>
            You can make deposits using a debit card or a bank transfer.
            Debit cards are the quickest way to deposit but there is a limit of
            &pound;10,000 per transaction and you are required to use your 3DS for added security.
            For bank transfers, these can take a few days to show in your account but are usually
            much quicker and sometimes can show within a day.
          </p>
        </div>
        <div class="col-sm-6">
          <base-field label="Bank Account Name">
            <base-input v-model="payload.bank" personal placeholder="bank account name" />
          </base-field>
          <base-field label="Account Number">
            <base-input v-model="payload.accountNumber" personal placeholder="account number" type="number" />
          </base-field>
          <base-field label="Sort Code">
            <base-input v-model="payload.sortCode" personal placeholder="sort code" type="number" />
          </base-field>
          <base-field label="IBAN">
            <base-input v-model="payload.iban" personal placeholder="IBAN" />
          </base-field>
        </div>
      </div>

      <template v-slot:bottom>
        <div class="bg-light py-4">
          <div class="container">
            <div class="row align-items-center">
              <div class="col-sm-6">
                Estimated time to complete: <strong>3 minutes</strong>
              </div>
              <div class="col-sm-6 text-right">
                <base-button icon-right="arrow-right" :loading="saving" primary submit>Continue</base-button>
              </div>
            </div>
          </div>
        </div>
      </template>
    </base-content>
  </form>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

import HeroHeader from '@/components/HeroHeader.vue'

export default {
  created () {
    this.account = this.$auth.user.accounts.find(account => account._id === this.$route.params.id)
    this.payload = this.schema
  },

  data: () => ({
    account: {},
    payload: {},
    saving: false
  }),

  components: {
    HeroHeader
  },

  computed: {
    ...mapGetters({
      schema: 'core/bank-accounts/schema'
    }),

    ...mapState({
      bank: store => store.core.bankAccounts.entity
    })
  },

  methods: {
    async submit () {
      this.saving = true
      this.payload.user = this.$auth.user._id

      await this.$store.dispatch('core/bank-accounts/create', this.payload)
      await this.$store.dispatch('core/accounts/update', {
        _id: this.account._id,
        bank: this.bank._id
      })

      this.$router.push({ name: 'account.ready',
        params: {
          id: this.account._id
        } })
    }
  }
}
</script>
